import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardMedia from '@material-ui/core/CardMedia';
import listMenuChildTypes from '../../constants/MenuChildType';
import CoppyButton from '../atoms/CoppyButton';
import enabledStripeBilling from '../../constants/StripeBilling';

const styles = {
  detailTable: {
    width: '100%'
  },
  tableCellItem: {
    borderTop: '1px solid #DDDDDD',
    borderBottom: '1px solid #DDDDDD',
    backgroundColor: '#F7F7F7',
    width: 200
  },
  tableCellData: {
    borderTop: '1px solid #DDDDDD',
    borderBottom: '1px solid #DDDDDD'
  },
  userImage: {
    width: '100px',
    height: '100px'
  },
  tag: {
    margin: '0px 10px 0px 0px',
    backgroundColor: '#fee'
  },
  breakLine: {
    whiteSpace: 'pre-line'
  }
};

function formatDate(unformatted) {
  const date = new Date(unformatted);
  const month =
    date.getMonth() < 9 ? `0${date.getMonth() + 1}` : `${date.getMonth() + 1}`;
  const day = date.getDate() < 10 ? `0${date.getDate()}` : `${date.getDate()}`;
  return `${date.getFullYear()}/${month}/${day}`;
}

const enhance = compose(connect());

const ShopTable = enhance(
  ({
    classes,
    menuName,
    price,
    taxTypeStr,
    reducedTaxTypeStr,
    description,
    createdAt,
    updatedAt,
    tags,
    image,
    comboMenu,
    priceCombo,
    quantityRelease,
    quantityPromotion,
    promotionDescription,
    usageLimit,
    expiration,
    expirationEndDate,
    subscription,
    subscriptionIntervalCount,
    subscriptionInterval,
    shopId,
    shopName,
    menuId,
    menuChildType,
    shashokuOptionStr,
    showHide,
    genreName,
    situationNames,
    userTargetNames,
    menuLimitTotal,
    isFukuoka
  }) => {
    const childTypeFound = listMenuChildTypes.find(
      item => item.id === menuChildType
    );
    let menuChildTypeStr = '';
    if (childTypeFound) {
      menuChildTypeStr = childTypeFound.name;
      if (isFukuoka) {
        if (childTypeFound.id === 1) {
          menuChildTypeStr = '通常（教室別）';
        } else if (childTypeFound.id === 4) {
          menuChildTypeStr = 'グループ共通';
        }
      }
    }

    return (
      <Table className={classes.detailTable}>
        <TableRow>
          <TableCell className={classes.tableCellItem}>
            {isFukuoka ? '教室ID' : '店舗ID'}
          </TableCell>
          <TableCell className={classes.tableCellData}>{shopId}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={classes.tableCellItem}>
            {isFukuoka ? '教室名' : '店舗名'}
          </TableCell>
          <TableCell className={classes.tableCellData}>{shopName}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={classes.tableCellItem}>
            {isFukuoka ? 'コースID' : 'メニューID'}
          </TableCell>
          <TableCell className={classes.tableCellData}>{menuId}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={classes.tableCellItem}>
            {isFukuoka ? 'コース名' : 'メニュー名'}
          </TableCell>
          <TableCell className={classes.tableCellData}>{menuName}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={classes.tableCellItem}>
            {isFukuoka ? 'コース種別' : '種別'}
          </TableCell>
          <TableCell className={classes.tableCellData}>
            {menuChildTypeStr}
          </TableCell>
        </TableRow>
        {!isFukuoka && (
          <TableRow>
            <TableCell className={classes.tableCellItem}>
              メニュー表示
            </TableCell>
            <TableCell className={classes.tableCellData}>
              {shashokuOptionStr}
            </TableCell>
          </TableRow>
        )}
        {subscription === 1 && enabledStripeBilling === true && (
          <>
            <TableRow>
              <TableCell className={classes.tableCellItem}>
                サブスクチケット
              </TableCell>
              <TableCell className={classes.tableCellData}>✔</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>購入頻度</TableCell>
              <TableCell className={classes.tableCellData}>
                {`${subscriptionIntervalCount}${
                  subscriptionInterval === 'WEEK' ? '週間' : 'ヶ月'
                }1回`}
              </TableCell>
            </TableRow>
          </>
        )}
        <TableRow>
          <TableCell className={classes.tableCellItem}>
            {isFukuoka ? '金額' : '価格'}
          </TableCell>
          <TableCell className={classes.tableCellData}>{price}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={classes.tableCellItem}>税区分</TableCell>
          <TableCell className={classes.tableCellData}>{taxTypeStr}</TableCell>
        </TableRow>
        {!isFukuoka && (
          <>
            <TableRow>
              <TableCell className={classes.tableCellItem}>
                軽減税率対象
              </TableCell>
              <TableCell className={classes.tableCellData}>
                {reducedTaxTypeStr}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>ジャンル</TableCell>
              <TableCell className={classes.tableCellData}>
                {genreName}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>
                シチュエーション
              </TableCell>
              <TableCell className={classes.tableCellData}>
                {situationNames}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>贈り相手</TableCell>
              <TableCell className={classes.tableCellData}>
                {userTargetNames}
              </TableCell>
            </TableRow>
          </>
        )}

        <TableRow>
          <TableCell className={classes.tableCellItem}>説明</TableCell>
          <TableCell
            className={`${classes.tableCellData} ${classes.breakLine}`}
          >
            {description}
          </TableCell>
        </TableRow>
        {!isFukuoka && (
          <>
            <TableRow>
              <TableCell className={classes.tableCellItem}>タグ</TableCell>
              <TableCell className={classes.tableCellData}>
                <div>
                  {tags.map(tag => {
                    return <span className={classes.tag}>{tag.tagName}</span>;
                  })}
                </div>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>表示</TableCell>
              <TableCell className={classes.tableCellData}>
                {showHide ? '表示' : '非表示'}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>
                ごちボタン
              </TableCell>
              <TableCell className={classes.tableCellData}>
                <CoppyButton
                  linkToCopy={`https://web.app-gochimeshi.com/?id=${menuId}`}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>登録日時</TableCell>
              <TableCell className={classes.tableCellData}>
                {formatDate(createdAt)}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>更新日時</TableCell>
              <TableCell className={classes.tableCellData}>
                {formatDate(updatedAt)}
              </TableCell>
            </TableRow>
          </>
        )}
        <TableRow>
          <TableCell className={classes.tableCellItem}>画像</TableCell>
          <TableCell className={classes.tableCellData}>
            {image && (
              <Card className={classes.userImage}>
                <CardActionArea>
                  <CardMedia component="img" image={image} />
                </CardActionArea>
              </Card>
            )}
          </TableCell>
        </TableRow>
        {menuChildType !== 5 && !isFukuoka && (
          <TableRow>
            <TableCell className={classes.tableCellItem}>タイプ</TableCell>
            <TableCell className={classes.tableCellData}>
              {comboMenu === 1 ? '回数券' : '普通'}
            </TableCell>
          </TableRow>
        )}
        {menuChildType !== 3 &&
          menuChildType !== 5 &&
          comboMenu === 0 &&
          !isFukuoka && (
            <TableRow>
              <TableCell className={classes.tableCellItem}>利用方法</TableCell>
              <TableCell className={classes.tableCellData}>
                {menuLimitTotal === 1 ? '一円単位利用' : '一枚単位利用'}
              </TableCell>
            </TableRow>
          )}
        {comboMenu === 1 && (
          <>
            <TableRow>
              <TableCell className={classes.tableCellItem}>
                単価 × 発行枚数
              </TableCell>
              <TableCell className={classes.tableCellData}>
                {`${priceCombo}円ｘ${quantityRelease}枚`}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>
                付与無料枚数
              </TableCell>
              <TableCell className={classes.tableCellData}>
                {quantityPromotion ? `${quantityPromotion}枚` : ''}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>おまけ</TableCell>
              <TableCell
                className={`${classes.tableCellData} ${classes.breakLine}`}
              >
                {promotionDescription}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>利用制限</TableCell>
              <TableCell className={classes.tableCellData}>
                {usageLimit === 1 ? '1日1枚' : 'なし'}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>利用期限</TableCell>
              <TableCell className={classes.tableCellData}>
                {expiration ? `${expiration}日間` : expirationEndDate}
              </TableCell>
            </TableRow>
          </>
        )}
      </Table>
    );
  }
);

export default withStyles(styles)(ShopTable);
